module.exports = __webpack_public_path__ + "static/media/vibrant-thumbnail1.b516478b.png";